export default __webpack_public_path__ + "static/media/upload-icon-purple.19544f21.svg";